// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.prompt__ClockWidget-module--CZWDx {
    font-size: calc(var(--px) * 15);
    font-weight: 600;
    color: var(--color-text-primary);
}

.row__ClockWidget-module--BG1rK {
    display: flex;
    align-items: center;
    gap: calc(var(--px) * 18);
}

.face__ClockWidget-module--PQ4ku {
    position: relative;
    flex-shrink: 0;
    width: calc(var(--px) * 116);
    height: calc(var(--px) * 116);
    border-radius: 50%;
    background: var(--color-primary-50);
    border: calc(var(--px) * 4) solid var(--color-primary-600);
}

.tickWrap__ClockWidget-module--vjFpw {
    position: absolute;
    inset: 0;
}

.tick__ClockWidget-module--rvtcv {
    position: absolute;
    left: 50%;
    top: calc(var(--px) * 5);
    width: calc(var(--px) * 3);
    margin-left: calc(var(--px) * -1.5);
    border-radius: calc(var(--px) * 2);
    background: var(--color-primary-700);
}

.hourHand__ClockWidget-module--d5snO,
.minuteHand__ClockWidget-module--CDVIu {
    position: absolute;
    left: 50%;
    bottom: 50%;
    border-radius: calc(var(--px) * 3);
    background: var(--color-neutral-900);
    transform-origin: 50% 100%;
}

.hourHand__ClockWidget-module--d5snO {
    width: calc(var(--px) * 5);
    height: calc(var(--px) * 28);
    margin-left: calc(var(--px) * -2.5);
    transform: rotate(194.5deg);
}

.animatedHour__ClockWidget-module--yLpO8 {
    animation: hh__ClockWidget-module--v7XEH 8s ease-in-out infinite;
}

.minuteHand__ClockWidget-module--CDVIu {
    width: calc(var(--px) * 3);
    height: calc(var(--px) * 42);
    margin-left: calc(var(--px) * -1.5);
    transform: rotate(174deg);
}

.animatedMinute__ClockWidget-module--vrwS6 {
    animation: hm__ClockWidget-module--HLGsg 8s ease-in-out infinite;
}

@keyframes hh__ClockWidget-module--v7XEH {
    0% {
        transform: rotate(150deg);
    }
    30%, 92% {
        transform: rotate(194.5deg);
    }
    100% {
        transform: rotate(150deg);
    }
}

@keyframes hm__ClockWidget-module--HLGsg {
    0% {
        transform: rotate(0deg);
    }
    30%, 92% {
        transform: rotate(174deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.centreCap__ClockWidget-module--H7V7R {
    position: absolute;
    left: 50%;
    top: 50%;
    width: calc(var(--px) * 12);
    height: calc(var(--px) * 12);
    margin: calc(var(--px) * -6) 0 0 calc(var(--px) * -6);
    border-radius: 50%;
    background: var(--home-color-orange);
    border: calc(var(--px) * 1.5) solid var(--color-neutral-900);
}

.digits__ClockWidget-module--s4bho {
    display: flex;
    align-items: center;
    gap: calc(var(--px) * 6);
    font-size: calc(var(--px) * 30);
    font-weight: 800;
    color: var(--color-text-primary);
}

.digitBox__ClockWidget-module--vqlvS {
    display: flex;
    align-items: center;
    justify-content: center;
    width: calc(var(--px) * 62);
    height: calc(var(--px) * 56);
    border-radius: calc(var(--px) * 12);
    border: calc(var(--px) * 1.5) solid var(--color-neutral-400);
    background: var(--color-neutral-50);
}

.digit__ClockWidget-module--xngmn {
    opacity: 1;
}

.digit1__ClockWidget-module--EaE5B {
    animation: d1__ClockWidget-module--Gapbv 8s infinite;
}

.digit2__ClockWidget-module--XT_6H {
    animation: d2__ClockWidget-module--pfChC 8s infinite;
}

.digit3__ClockWidget-module--mdlZo {
    animation: d3__ClockWidget-module--f5vck 8s infinite;
}

.digit4__ClockWidget-module--NlRyo {
    animation: d4__ClockWidget-module--rZQZn 8s infinite;
}

@keyframes d1__ClockWidget-module--Gapbv {
    0%, 34% {
        opacity: 0;
        transform: translateY(calc(var(--px) * 8));
    }
    38%, 92% {
        opacity: 1;
        transform: none;
    }
    100% {
        opacity: 0;
    }
}

@keyframes d2__ClockWidget-module--pfChC {
    0%, 38% {
        opacity: 0;
        transform: translateY(calc(var(--px) * 8));
    }
    42%, 92% {
        opacity: 1;
        transform: none;
    }
    100% {
        opacity: 0;
    }
}

@keyframes d3__ClockWidget-module--f5vck {
    0%, 43% {
        opacity: 0;
        transform: translateY(calc(var(--px) * 8));
    }
    47%, 92% {
        opacity: 1;
        transform: none;
    }
    100% {
        opacity: 0;
    }
}

@keyframes d4__ClockWidget-module--rZQZn {
    0%, 47% {
        opacity: 0;
        transform: translateY(calc(var(--px) * 8));
    }
    51%, 92% {
        opacity: 1;
        transform: none;
    }
    100% {
        opacity: 0;
    }
}

.feedback__ClockWidget-module--NnJ4B {
    display: flex;
    align-items: center;
    gap: calc(var(--px) * 10);
    padding: calc(var(--px) * 10) calc(var(--px) * 12);
    border-radius: calc(var(--px) * 14);
    background: var(--color-feedback-correct-tint);
}

.rise__ClockWidget-module--oojEk {
    animation: rise__ClockWidget-module--oojEk 8s ease-out infinite;
}

@keyframes rise__ClockWidget-module--oojEk {
    0%, 53% {
        opacity: 0;
        transform: translateY(calc(var(--px) * 12));
    }
    58%, 92% {
        opacity: 1;
        transform: none;
    }
    100% {
        opacity: 0;
    }
}

.feedbackText__ClockWidget-module--hQzIm {
    font-size: calc(var(--px) * 14);
    font-weight: 700;
    color: var(--color-feedback-correct);
}
`, "",{"version":3,"sources":["webpack://./src/main/ui/home/components/ClockWidget.module.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,4BAA4B;IAC5B,6BAA6B;IAC7B,kBAAkB;IAClB,mCAAmC;IACnC,0DAA0D;AAC9D;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,wBAAwB;IACxB,0BAA0B;IAC1B,mCAAmC;IACnC,kCAAkC;IAClC,oCAAoC;AACxC;;AAEA;;IAEI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,kCAAkC;IAClC,oCAAoC;IACpC,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,mCAAmC;IACnC,2BAA2B;AAC/B;;AAEA;IACI,gEAAqC;AACzC;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,mCAAmC;IACnC,yBAAyB;AAC7B;;AAEA;IACI,gEAAqC;AACzC;;AAEA;IACI;QACI,yBAAyB;IAC7B;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,2BAA2B;IAC3B,4BAA4B;IAC5B,qDAAqD;IACrD,kBAAkB;IAClB,oCAAoC;IACpC,4DAA4D;AAChE;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,+BAA+B;IAC/B,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,4BAA4B;IAC5B,mCAAmC;IACnC,4DAA4D;IAC5D,mCAAmC;AACvC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,oDAAyB;AAC7B;;AAEA;IACI,oDAAyB;AAC7B;;AAEA;IACI,oDAAyB;AAC7B;;AAEA;IACI,oDAAyB;AAC7B;;AAEA;IACI;QACI,UAAU;QACV,0CAA0C;IAC9C;IACA;QACI,UAAU;QACV,eAAe;IACnB;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;QACV,0CAA0C;IAC9C;IACA;QACI,UAAU;QACV,eAAe;IACnB;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;QACV,0CAA0C;IAC9C;IACA;QACI,UAAU;QACV,eAAe;IACnB;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;QACV,0CAA0C;IAC9C;IACA;QACI,UAAU;QACV,eAAe;IACnB;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kDAAkD;IAClD,mCAAmC;IACnC,8CAA8C;AAClD;;AAEA;IACI,+DAAoC;AACxC;;AAEA;IACI;QACI,UAAU;QACV,2CAA2C;IAC/C;IACA;QACI,UAAU;QACV,eAAe;IACnB;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,oCAAoC;AACxC","sourcesContent":[".prompt {\n    font-size: calc(var(--px) * 15);\n    font-weight: 600;\n    color: var(--color-text-primary);\n}\n\n.row {\n    display: flex;\n    align-items: center;\n    gap: calc(var(--px) * 18);\n}\n\n.face {\n    position: relative;\n    flex-shrink: 0;\n    width: calc(var(--px) * 116);\n    height: calc(var(--px) * 116);\n    border-radius: 50%;\n    background: var(--color-primary-50);\n    border: calc(var(--px) * 4) solid var(--color-primary-600);\n}\n\n.tickWrap {\n    position: absolute;\n    inset: 0;\n}\n\n.tick {\n    position: absolute;\n    left: 50%;\n    top: calc(var(--px) * 5);\n    width: calc(var(--px) * 3);\n    margin-left: calc(var(--px) * -1.5);\n    border-radius: calc(var(--px) * 2);\n    background: var(--color-primary-700);\n}\n\n.hourHand,\n.minuteHand {\n    position: absolute;\n    left: 50%;\n    bottom: 50%;\n    border-radius: calc(var(--px) * 3);\n    background: var(--color-neutral-900);\n    transform-origin: 50% 100%;\n}\n\n.hourHand {\n    width: calc(var(--px) * 5);\n    height: calc(var(--px) * 28);\n    margin-left: calc(var(--px) * -2.5);\n    transform: rotate(194.5deg);\n}\n\n.animatedHour {\n    animation: hh 8s ease-in-out infinite;\n}\n\n.minuteHand {\n    width: calc(var(--px) * 3);\n    height: calc(var(--px) * 42);\n    margin-left: calc(var(--px) * -1.5);\n    transform: rotate(174deg);\n}\n\n.animatedMinute {\n    animation: hm 8s ease-in-out infinite;\n}\n\n@keyframes hh {\n    0% {\n        transform: rotate(150deg);\n    }\n    30%, 92% {\n        transform: rotate(194.5deg);\n    }\n    100% {\n        transform: rotate(150deg);\n    }\n}\n\n@keyframes hm {\n    0% {\n        transform: rotate(0deg);\n    }\n    30%, 92% {\n        transform: rotate(174deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.centreCap {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    width: calc(var(--px) * 12);\n    height: calc(var(--px) * 12);\n    margin: calc(var(--px) * -6) 0 0 calc(var(--px) * -6);\n    border-radius: 50%;\n    background: var(--home-color-orange);\n    border: calc(var(--px) * 1.5) solid var(--color-neutral-900);\n}\n\n.digits {\n    display: flex;\n    align-items: center;\n    gap: calc(var(--px) * 6);\n    font-size: calc(var(--px) * 30);\n    font-weight: 800;\n    color: var(--color-text-primary);\n}\n\n.digitBox {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: calc(var(--px) * 62);\n    height: calc(var(--px) * 56);\n    border-radius: calc(var(--px) * 12);\n    border: calc(var(--px) * 1.5) solid var(--color-neutral-400);\n    background: var(--color-neutral-50);\n}\n\n.digit {\n    opacity: 1;\n}\n\n.digit1 {\n    animation: d1 8s infinite;\n}\n\n.digit2 {\n    animation: d2 8s infinite;\n}\n\n.digit3 {\n    animation: d3 8s infinite;\n}\n\n.digit4 {\n    animation: d4 8s infinite;\n}\n\n@keyframes d1 {\n    0%, 34% {\n        opacity: 0;\n        transform: translateY(calc(var(--px) * 8));\n    }\n    38%, 92% {\n        opacity: 1;\n        transform: none;\n    }\n    100% {\n        opacity: 0;\n    }\n}\n\n@keyframes d2 {\n    0%, 38% {\n        opacity: 0;\n        transform: translateY(calc(var(--px) * 8));\n    }\n    42%, 92% {\n        opacity: 1;\n        transform: none;\n    }\n    100% {\n        opacity: 0;\n    }\n}\n\n@keyframes d3 {\n    0%, 43% {\n        opacity: 0;\n        transform: translateY(calc(var(--px) * 8));\n    }\n    47%, 92% {\n        opacity: 1;\n        transform: none;\n    }\n    100% {\n        opacity: 0;\n    }\n}\n\n@keyframes d4 {\n    0%, 47% {\n        opacity: 0;\n        transform: translateY(calc(var(--px) * 8));\n    }\n    51%, 92% {\n        opacity: 1;\n        transform: none;\n    }\n    100% {\n        opacity: 0;\n    }\n}\n\n.feedback {\n    display: flex;\n    align-items: center;\n    gap: calc(var(--px) * 10);\n    padding: calc(var(--px) * 10) calc(var(--px) * 12);\n    border-radius: calc(var(--px) * 14);\n    background: var(--color-feedback-correct-tint);\n}\n\n.rise {\n    animation: rise 8s ease-out infinite;\n}\n\n@keyframes rise {\n    0%, 53% {\n        opacity: 0;\n        transform: translateY(calc(var(--px) * 12));\n    }\n    58%, 92% {\n        opacity: 1;\n        transform: none;\n    }\n    100% {\n        opacity: 0;\n    }\n}\n\n.feedbackText {\n    font-size: calc(var(--px) * 14);\n    font-weight: 700;\n    color: var(--color-feedback-correct);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"prompt": `prompt__ClockWidget-module--CZWDx`,
	"row": `row__ClockWidget-module--BG1rK`,
	"face": `face__ClockWidget-module--PQ4ku`,
	"tickWrap": `tickWrap__ClockWidget-module--vjFpw`,
	"tick": `tick__ClockWidget-module--rvtcv`,
	"hourHand": `hourHand__ClockWidget-module--d5snO`,
	"minuteHand": `minuteHand__ClockWidget-module--CDVIu`,
	"animatedHour": `animatedHour__ClockWidget-module--yLpO8`,
	"hh": `hh__ClockWidget-module--v7XEH`,
	"animatedMinute": `animatedMinute__ClockWidget-module--vrwS6`,
	"hm": `hm__ClockWidget-module--HLGsg`,
	"centreCap": `centreCap__ClockWidget-module--H7V7R`,
	"digits": `digits__ClockWidget-module--s4bho`,
	"digitBox": `digitBox__ClockWidget-module--vqlvS`,
	"digit": `digit__ClockWidget-module--xngmn`,
	"digit1": `digit1__ClockWidget-module--EaE5B`,
	"d1": `d1__ClockWidget-module--Gapbv`,
	"digit2": `digit2__ClockWidget-module--XT_6H`,
	"d2": `d2__ClockWidget-module--pfChC`,
	"digit3": `digit3__ClockWidget-module--mdlZo`,
	"d3": `d3__ClockWidget-module--f5vck`,
	"digit4": `digit4__ClockWidget-module--NlRyo`,
	"d4": `d4__ClockWidget-module--rZQZn`,
	"feedback": `feedback__ClockWidget-module--NnJ4B`,
	"rise": `rise__ClockWidget-module--oojEk`,
	"feedbackText": `feedbackText__ClockWidget-module--hQzIm`
};
export default ___CSS_LOADER_EXPORT___;
